module.exports = __webpack_public_path__ + "img/popup-game-sucai.b5fa8a89.png";